import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import CookieBanner from "@/components/CookieBanner";

function ScrollToHash() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Defer to allow page render
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, hash, key]);
  return null;
}

function GlobalReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    const targets = document.querySelectorAll(".mk-reveal:not(.is-visible)");
    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  });
  return null;
}

function App() {
  return (
    <div className="App" data-testid="mackbe-app-root">
      <BrowserRouter>
        <ScrollToHash />
        <GlobalReveal />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <CookieBanner />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(10, 22, 40, 0.95)",
              border: "1px solid rgba(255,255,255,0.12)",
              color: "#F8FAFC",
              backdropFilter: "blur(16px)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
